module.exports = __webpack_public_path__ + "img/rules_4.ee8985af.png";